import style from "./dashboard-grid.scss";
import React from "react";

export function DashboardGrid(props: { children: JSX.Element[] }): JSX.Element {
    return <div className={style.dashboardGrid}>{props.children}</div>;
}
